'use client'

import * as React from 'react'

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@ui/components/shadcn/ui'

import { NavLogo } from '@web-app/components/layout/SidebarAppLayout/nav-logo'
import { NavMain } from '@web-app/components/layout/SidebarAppLayout/nav-main'
import { NavUser } from '@web-app/components/layout/SidebarAppLayout/nav-user'

export function AppSidebar({
  userData,
  ...props
}: {
  userData: { name: string; email: string }
} & React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <NavLogo />
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name: userData?.name ?? 'Your Account',
            email: userData?.email ?? '',
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
